import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const UserEditProfile = lazyLoader(
  () =>
    import("Containers/Settings/UserProfile/UserEditProfile/UserEditProfile")
);

export const EditUserProfile = () => {
  return (
    <Layout>
      <UserEditProfile />
    </Layout>
  );
};
